import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import corps from "images/visage.jpg";
import cheveux from "images/cheveux1.jpg";
import complement from "images/complement alimentaire.jpg";
import packs from "images/pack.jpg";
  import shampoing from "images/shampoing.jpg";
import garence from "images/garence.jpg";

import tw from "twin.macro";
import Light from "./headers/light";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footerr from "./footers/Footer";
import { useTranslation } from "react-i18next";

const PrimaryButton = tw.a`
  px-[28px] py-[12px]
  text-[16px]
  font-normal
  bg-[#428964] text-gray-100 
  hocus:bg-[#428964] 
  focus:shadow-outline focus:outline-none 
  transition duration-300
`;

const ButtonIcon = tw(FontAwesomeIcon)`mr-2`;

// ✅ Composant réutilisable
const CatalogueSection = ({ title, text, img, pdfFile, reverse, t }) => (
  <Container fluid className="py-5">
    <Row className={`align-items-center gx-0 gy-4 flex-column flex-md-row ${reverse ? "flex-md-row-reverse" : ""}`}>
      
      {/* Texte */}
      <Col xs={12} md={6} className="px-4 d-flex flex-column justify-content-center" style={{ marginBottom: "16px" }}>
        <h2 className="fw-bold mb-3 text-center text-md-start" style={{ color: "#428964", fontSize: "2rem" }}>
          {title}
        </h2>
        <p className="text-muted mb-4 text-center text-md-start">{text}</p>

        <div className="d-flex justify-content-center justify-content-md-start mb-3">
          <PrimaryButton href={`/${pdfFile}`} download>
            <ButtonIcon icon={faShoppingCart} />
            {t("catalogue.download")}
          </PrimaryButton>
        </div>
      </Col>

      {/* Image */}
      <Col xs={12} md={6} className="p-0 d-flex justify-content-center align-items-center" style={{ marginBottom: "16px" }}>
        <img
          src={img}
          alt={title}
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "auto",
            objectFit: "cover",
            borderRadius: "16px",
          }}
        />
      </Col>
    </Row>
  </Container>
);

const Catalogue = () => {
  const { t } = useTranslation();

  return (
    <AnimationRevealPage>
      <Light />
      <div
        style={{
          padding: "80px 0",
          margin: "0px",
          textAlign: "center",
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1
          style={{
            color: "#000000",
            fontWeight: "bold",
            fontSize: "52px",
            margin: 0,
          }}
        >
          {t("catalogue.title")}
        </h1>
      </div>

      <CatalogueSection
        title={t("catalogue.corps.title")}
        text={t("catalogue.corps.text")}
        img={corps}
  pdfFile="corps.pdf"
          t={t}

      />

      <CatalogueSection
        title={t("catalogue.cheveux.title")}
        text={t("catalogue.cheveux.text")}
        img={cheveux}
  pdfFile="cheveux.pdf"
          t={t}

        reverse
      />

      <CatalogueSection
        title={t("catalogue.nutrition.title")}
        text={t("catalogue.nutrition.text")}
        img={complement}
  pdfFile="complement.pdf"
          t={t}

      />

      <CatalogueSection
        title={t("catalogue.packs.title")}
        text={t("catalogue.packs.text")}
        img={packs}
  pdfFile="packs.pdf"
          t={t}

        reverse
      />
 <CatalogueSection
        title={t("catalogue.garence.title")}
        text={t("catalogue.garence.text")}
        img={garence}
  pdfFile="garence.pdf"
          t={t}
      />
 <CatalogueSection
        title={t("catalogue.shampoing.title")}
        text={t("catalogue.shampoing.text")}
        img={shampoing}
  pdfFile="1litre.pdf"
          t={t}

        reverse
      />


      <Footerr />
    </AnimationRevealPage>
  );
};

export default Catalogue;
